import { API_BASE_URL, ACCESS_TOKEN } from '../constants';

const request = (options) => {
    const headers = new Headers({
        'Content-Type': 'application/json',
    })

    const defaults = {headers: headers};
    options = Object.assign({}, defaults, options);

    return fetch(options.url, options)
    .then(response => 
        response.json().then(json => {
            if(!response.ok) {
                return Promise.reject(json);
            }
            return json;
        }).catch(error => {
		    console.log(error);
		})
    );
};
export function changePassToken(changePassRequest) {
    return request({
        url: API_BASE_URL + "/auth/changePassToken",
        method: 'POST',
        body: JSON.stringify(changePassRequest)
    });
}